import { Component, OnInit } from "@angular/core";

import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { MissionService, DataStore, HTTPCallsService } from "src/app/_services";
import { ThingAccessories } from "src/app/_models/thingAccessories";
import { ThingStatus } from "src/app/_models/thingStatus";
import { ThingControl } from "src/app/_models/thingControl";
import { Subscription } from "rxjs";
import { NgxIndexedDBService } from 'ngx-indexed-db';
@Component({
  selector: "app-thing-settings-edit",
  templateUrl: "./thing-settings-edit.component.html",
  styleUrls: ["./thing-settings-edit.component.css"]
})
export class ThingSettingsEditComponent implements OnInit {
  deviceLocation: FormGroup;
  roomName: FormGroup;
  deviceTypeName: FormGroup;
  deviceSwitchName: FormGroup;
  private router: Router;
  selectedThing: any;
  availableAccessory: Map<string, ThingAccessories> = new Map<
    string,
    ThingAccessories
  >();
  availableStatus: Map<string, ThingStatus> = new Map<string, ThingStatus>();
  availableControls: Map<string, ThingControl> = new Map<
    string,
    ThingControl
  >();

  selectedMacId: string;
  selectedAccessoryId: string;
  subscription: Subscription;
  placeNameSet = new Set();
  selectedDeviceLocationString = "Home";
  currentSwitch: string;
  deviceTypeMap: Map<string, any> = new Map<string, any>();
  updatedThing: any;
  currentIdentifier: string;
  accessoryDetailMapString = [];
  addNewRoom: boolean;
  accessoryIdentifierinput: string;
  updatedAccesoryDetails: any;
  loading: boolean

  inputSave = false;
  deviceTypeNameArray = [
    "Light",
    "Socket",
    "AC",
    "Fan",
    "Washing Machine",
    "Laptop",
    "Refrigerator",
    "Printer",
    "Wifi",
    "Microwave",
    "TV",
    "Light Array",
    "Geyser",
    "Speaker",
    "Water Purifier",
    "Chandelier",
    "Chimney",
    "Exhaust Fan",
    "Projector"
  ];
  roomNameArray = [
    "Study Room",
    "Stairs",
    "Prayer Room",
    "Dressing Room",
    "Guest Bedroom",
    "Bathroom",
    "Entertainment",
    "Living Room",
    "Kids Bedroom",
    "Cellar",
    "Garden",
    "Dinning Room",
    "Master Bedroom",
    "Garage",
    "Hall Way",
    "Kitchen"
  ];
  selectedRoomNameString = "";
  deviceTypeString = "";
  toDetailPage = "";

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,

    private missionService: MissionService,
    private dataStore: DataStore,
    private httpService: HTTPCallsService,
    private dbService: NgxIndexedDBService
  ) { }

  ngOnInit() {
    this.loading = true
    this.inputSave = false;
    this.addNewRoom = false;
    this.listOfplaceName();
    this.selectedMacId = this.route.snapshot.paramMap.get("id");
    this.toDetailPage = this.selectedMacId.split("/")[1];

    this.prepareThingData()


    this.deviceLocation = this.formBuilder.group({
      deviceLocationParam: ["", Validators.required]
    });
    this.roomName = this.formBuilder.group({
      roomNameParam: ["", Validators.required]
    });
    this.deviceTypeName = this.formBuilder.group({
      deviceTypeNameParam: ["", Validators.required]
    });
    this.deviceSwitchName = this.formBuilder.group({
      switchName: ["", Validators.required]
    });
  }

  prepareThingData() {
    this.dbService.getByKey("Things", this.selectedMacId).then(selectedData => {
      if (selectedData) {
        this.selectedThing = selectedData['thing'];

        this.selectedRoomNameString = this.selectedThing.roomName;
        this.selectedDeviceLocationString = this.selectedThing.thingsLocation.placeName;
        this.selectedThing.accessories.forEach(accessory => {
          this.availableAccessory.set(
            this.selectedThing.macId + "/" + accessory.accessoryIdentifier,
            accessory
          );
          if (accessory.statusList.length > 0) {
            accessory.statusList.forEach(status => {
              this.availableStatus.set(
                this.selectedThing.macId +
                "/" +
                accessory.accessoryIdentifier +
                "/" +
                status.statusId,
                status
              );
              this.deviceTypeMap.set(status.accessoryIdentifier, {
                displayName: accessory.accessoryType,
                switch: accessory.thingName
              });
              this.loading = false
            });
          }
          if (accessory.thingControl.length > 0) {
            accessory.thingControl.forEach(control => {
              this.availableControls.set(
                this.selectedThing.macId +
                "/" +
                accessory.accessoryIdentifier +
                "/" +
                control.controlIdentifier,
                control
              );
            });
          }
        });

      }
    });
  }
  listOfplaceName() {

    this.dbService.getAll("Things").then(Data => {
      Data.forEach(element => {
        if (
          element['thing'].thingsLocation.placeName) {
          this.placeNameSet.add(element['thing'].thingsLocation.placeName)
        }
      });
    });
  }

  inputChange(accessoryIdentifier) {

    this.inputSave = true;
    this.accessoryIdentifierinput = accessoryIdentifier;
  }
  deviceNmeAction(accessoryIdentifier) {
    this.inputSave = false;
    if (this.deviceSwitchName.value.switchName !== "") {
      var switchNameChange = {
        key: accessoryIdentifier,
        value: this.deviceSwitchName.value
      };
      for (var [key, value] of this.deviceTypeMap) {
        if (key == switchNameChange.key) {
          this.deviceTypeMap.set(key, {
            displayName: value.displayName,
            switch: switchNameChange.value.switchName
          });
        }
      }
      this.deviceSwitchName.value.switchName = "";
    }
  }
  getRoomName(roomName) {
    if (roomName === "Add New Room") {
      this.addNewRoom = true;
    }
    this.selectedRoomNameString = roomName;
  }

  getDeviceLocation(deviceLocation) {
    this.selectedDeviceLocationString = deviceLocation;
  }

  getDeviceTypeName(deviceType, currentSwitch, currentIdentifier) {
    this.deviceTypeString = deviceType;
    this.currentSwitch = currentSwitch;
    this.currentIdentifier = currentIdentifier;
    this.deviceTypeMap.set(this.currentIdentifier, {
      displayName: this.deviceTypeString,
      switch: this.currentSwitch
    });
  }
  toThingSettingPage() {
    {
      var toSetting = this.selectedMacId.split("/")[1];
      this.router.navigate(["/dashboard/things"]);
    }
  }

  saveEdittedData() {
    var accessoriesDetails = this.selectedThing.accessories;
    //Below code gives the array of accessories
    accessoriesDetails.forEach(accessory => {
      for (var [key, value] of this.deviceTypeMap) {
        if (accessory.accessoryIdentifier == key) {
          var accessoryKey = accessory.accessoryIdentifier;

          this.accessoryDetailMapString.push({
            [accessoryKey]: {
              name: value.switch,

              accessoryType: value.displayName,
              linkingDetails: {
                addLinkMacId: "",
                removeLinkMacId: ""
              }
            }
          });
        }
      }
    });
    var accessoryArrayToObjects = {};
    for (var i = 0; i < this.accessoryDetailMapString.length; i++) {
      accessoryArrayToObjects[i] = this.accessoryDetailMapString[i];
    }

    let accessoryDetailObject = {};
    for (let res in accessoryArrayToObjects) {
      CombineObjects(accessoryArrayToObjects[res], accessoryDetailObject);
    }

    function CombineObjects(obj, variable) {
      for (let key of Object.keys(obj)) {
        if (!variable[key]) variable[key] = {};

        for (let innerKey of Object.keys(obj[key]))
          variable[key][innerKey] = obj[key][innerKey];
      }
    }

    Object.assign(
      accessoryDetailObject,
      { initialModel: this.selectedThing.initialModel },
      { initialVersion: this.selectedThing.initialVersion }
    );

    var userAccessObject = [];
    var userAccessArray;
    var status = [];
    var control = [];
    var selectedThingUserAccess = this.selectedThing.userAccess;

    selectedThingUserAccess.forEach(element => {
      var name = element.groupName;
      var userList = element.userList;
      element.statusAccess.forEach(innerStatuselement => {
        status.push(innerStatuselement.statusAccessList);
      });
      element.controlAccess.forEach(innerControlelement => {
        control.push(innerControlelement.controlAccessList);
      });
      (userAccessArray = {
        name: name,

        status: status,
        control: control,
        userList: userList
      }),
        userAccessObject.push(userAccessArray);
    });

    this.updatedThing = {
      admin: this.selectedThing.admins,
      _id: this.selectedThing.serverId,
      type: "thing",
      action: "update",
      macId: this.selectedThing.macId,
      thing: {
        manufacturerDetails: this.selectedThing.manufacturerDetails,
        location: {
          placeId: "",
          placeType: this.selectedThing.thingsLocation.placeType,
          placeName: this.selectedDeviceLocationString,
          latitude: this.selectedThing.thingsLocation.latitude,
          longitude: this.selectedThing.thingsLocation.longitude,
          canEditLocation: this.selectedThing.thingsLocation.canEditLocation
        },
        canChangeThingType: this.selectedThing.canChangeThingType,
        isLinkableThing: this.selectedThing.isLinkableThing,
        model: this.selectedThing.model,
        version: this.selectedThing.version,
        thingType: this.selectedThing.thingType,
        buildNumber: this.selectedThing.buildNumber,
        updatedBy: phoneNumber,
        groupBy: this.selectedThing.groupBy,
        accessoriesDetails: accessoryDetailObject,
        userAccess: userAccessObject,
        roomName: this.selectedRoomNameString
      },
      timeStamp: Date.now(),
      __v: 0
    };

    var payLoad = this.updatedThing;
    let currentUserData = JSON.parse(localStorage.getItem("currentUser"));

    var phoneNumber = currentUserData["phoneNumber"];
    var topic = phoneNumber + "/" + "out";

    this.httpService
      .mqttPublish(topic, payLoad, phoneNumber)
      .subscribe(data => console.log(data));
  }
}
